module.exports = __webpack_public_path__ + "img/pic-3.8cafe60f.png";